import ButtonChangeVerificationState from '../ButtonChangeVerificationState';
import { CardFooter } from '@/components/ui/card.tsx';
import { Button } from '@/components/ui/button.tsx';
import { cn } from '@/lib/utils';

interface TProps {
	userId: string;
	verificationId: string;
	deniedStateChange?: boolean;
	onClickAcceptDenyAllBtn: (acceptAll: boolean, userId: string) => void;
}

const PhotoVerificationGroupFooter = ({ userId, verificationId, deniedStateChange, onClickAcceptDenyAllBtn }: TProps) => (
	<CardFooter className={cn(
		'flex items-center justify-center p-4 pt-0 gap-2',
		'md:justify-end md:gap-4',
	)}>
		<Button
			type='button'
			variant={'destructive'}
			onClick={() => onClickAcceptDenyAllBtn(false, userId)}>
			Refuser tout
		</Button>
		<Button
			type='button'
			onClick={() => onClickAcceptDenyAllBtn(true, userId)}>
			Accepter tout
		</Button>
		{
			!deniedStateChange &&
			<ButtonChangeVerificationState verificationId={verificationId} />
		}
	</CardFooter>
);

export default PhotoVerificationGroupFooter;
